export const GOVERNANCE = [{ id: 'vote', link: 'https://snapshot.org/#/trisolarislabs.eth', label: 'Vote on Snapshot' }]
